import React, { useEffect, useState, useMemo } from "react";
import "../../../styles/client/joblistingclient.scss";
import PaginationClient from "../../../component/pagination/PaginationClient";
import JobFilterClient from "./JobFilterClient";
import JobView from "./jobView/JobView";
import SingleSelect from "../../../component/singleSelect/SingleSelect";
import { clientIds } from "../../../config/clients/clients";
import { useSelector } from "react-redux";
import FilterPageTwo from "./FilterPageTow";
import "../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import useClientConfig from "../../../config/careers/clientConfig";
import CareersCustomFooter from "../CareersFooter/CareersCustomFooterBase";

const JobListingsClient = (props: any) => {
  
  const { location, clientId, checkListControl, jobsList, setTableControl, tableControl, sortList, 
    displayPage, filterView, moveToJobViewPage, pageChange, filterListData, searchControlSubmit, 
    pageSizeChange, withinDisabled, withinDisabledLocClass, navigateToJobAlerts, navigateToJob } = props;

  const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
  const [noJobFoundStyle, setNoJobFoundStyle] = useState("");
  const [showPagination, setShowPagination] = useState(false);
  const { t } = useTranslation();
  const {clientSiteSettings} = useClientConfig();
  const langLabels = clientConfig?.data?.data?.clientSettings?.languageSettings;
  const jobListingLangLabels = langLabels?.jobListing?.[0];

  
  const checkJobFound = () => {
    if(tableControl.totalCount <= 0){
      setNoJobFoundStyle("no-data-found");
    }
  };

  useEffect(() => {
    checkJobFound();
  }, [tableControl.totalCount]);

  useEffect(() => {    
    if((jobsList?.data?.data?.jobs?.perPage === 5 && jobsList?.data?.data?.jobs?.totalRecord > 5) || 
      (jobsList?.data?.data?.jobs?.perPage === 10 && jobsList?.data?.data?.jobs?.totalRecord > 10) || 
      (jobsList?.data?.data?.jobs?.perPage === 20 && jobsList?.data?.data?.jobs?.totalRecord > 20) || 
      (jobsList?.data?.data?.jobs?.perPage === 25 && jobsList?.data?.data?.jobs?.totalRecord > 25)) {
        setShowPagination(!false);
      } else {
        setShowPagination(false);
      }
  }, [jobsList?.data?.data?.jobs?.perPage, jobsList?.data?.data?.jobs?.totalRecord]);

  //Use resolveLogo for customizing client based default business logo image
  const resolveLogo = () => {
    // had to use new variable to add logo in job listing cards as it was set for template_4 only
    const logoAtJobListing = clientSiteSettings?.logoAtJobListing;
    if(clientSiteSettings?.templateName === "template_4" || logoAtJobListing) {
      return clientConfig?.data?.data?.clientSettings?.logo;
    }
    else {
      return "https://stag-compliance-careers.s3.ap-southeast-2.amazonaws.com/career-doc-settings/uploads/no_image.png";
    }
  };

  const jobListingColorSettings = useMemo(() => {
    const colorSettings = clientConfig?.data?.data?.clientSettings?.colorSettings?.jobListing;
    return colorSettings?.[0];
  }, [clientConfig]);
  
  return (
    <>
      {(location.pathname === "/" || location.pathname === "/jobs") ?
        <div className="container" style={{background: jobListingColorSettings?.bodyBackground }}>

                <style>
                    {`
                        .default-theme-template-new-page-id-2 {
                            background: ${jobListingColorSettings?.bodyBackground} !important;
                        }
                       
                    `}
                </style>

          <JobFilterClient 
            tableControl = {tableControl}
            setTableControl = {setTableControl}
            filterListData = {filterListData}
            searchControlSubmit = {searchControlSubmit}
            withinDisabled = {withinDisabled}
            withinDisabledLocClass = {withinDisabledLocClass}
          />
          <div className="module-careers-listings">
            <div className="listings-top">
              { tableControl.totalCount > 0 ?
              <h5 className="h5-client" style={{color: jobListingColorSettings?.showingText}}>{t("Showing")}<span className="primary-color ms-2" style={{color: jobListingColorSettings?.showingNumbers}}>{ 
                (checkListControl && jobsList?.data?.data?.jobs?.totalRecord > 10) ? 
                  jobsList?.data?.data?.jobs?.totalJobCountPerPage :  
                    checkListControl ? 
                      jobsList?.data?.data?.jobs?.totalRecord : 
                        (jobsList?.data?.data?.jobs?.totalRecord > jobsList?.data?.data?.jobs?.totalJobCountPerPage) ? 
                          jobsList?.data?.data?.jobs?.totalJobCountPerPage : 
                            jobsList?.data?.data?.jobs?.totalRecord} </span>
                {t("of")}<span className="primary-color ms-2" style={{color: jobListingColorSettings?.showingNumbers}}>{jobsList?.data?.data?.jobs?.totalRecord}</span>
              </h5> : <h5 className="h5-client"></h5> }
              <div className="flex box-gap cust-common-select cust-common-select-dropdown cust-sort-display-select">
                <form className="sort">
                  <div className="form-group dropdown-field mobile-filter-field">
                    <label>{jobListingLangLabels?.sortBy}</label>
                    <SingleSelect className="sort-control"
                      placeholder="" onChange={(e: any) => {
                          setTableControl((prs: any) => {
                              return {
                                  ...prs,
                                  sort: e
                              };
                          });
                      }}
                      value={tableControl.sort}
                      options={sortList}
                      isSearchable={false}
                    />
                    {/* <select className="form-control normal-text-input mq-normal-text-input"
                      placeholder="" onChange={(e: any) => {
                        setTableControl((prs: any) => {
                            return {
                              ...prs,
                              sort: selectOption("sort", e)
                            };
                        });
                      }} value={tableControl.sort.value}> */}
                        {/* {sortList?.map((ress: any, id: number) => {
                            return (
                                <option key={id} value={ress.value}>{ress.label}</option>
                            );
                        })} */}
                    {/* </select> */}
                  </div>
                </form>
                <form className="sort">
                  <div className="form-group dropdown-field mobile-filter-field">
                    <label>{jobListingLangLabels?.display}</label>
                    <SingleSelect className="sort-control"
                        placeholder="" onChange={(e: any) => {
                            pageSizeChange(e);
                        }}
                        value={tableControl.pageSize}
                        options={displayPage}
                        isSearchable={false}
                    />
                    {/* <select className="form-control normal-text-input mq-normal-text-input" 
                      value={tableControl.pageSize.value}
                      onChange={(e: any) =>
                        setTableControl((prs: any) => {
                            return {
                                ...prs,
                                pageSize: selectOption("size", e)
                            };
                        })
                      }
                    > */}
                    {/* {displayPage?.map((ress: any, id: number) => {
                      return <option key={id} value={ress.value}>{ress.label}</option>;
                    })} */}
                    {/* </select> */}
                  </div>
                </form>
              </div>
            </div>
            {tableControl.data.length > 0 ?
              <>
                <div  className="flex">
                {tableControl.data.map((ress: any, i: number) => {
                  return (
                    <div key={ress.id} className="careers-listing">
                      <div className="inner" style={{border: `2px solid ${jobListingColorSettings?.jobBoxBorder}`, borderRadius: jobListingColorSettings?.jobBoxBorder ? "30px" : "" }}>
                        <div className="image">
                          <img src={ress.logo ? ress.logo : resolveLogo()} className="img-fluid" alt="logo" />
                        </div>
                        <div className="text">
                          <h5 className="h5-client main-job-title" data-attr-track-action="job_event_click" role="button" onClick={() => moveToJobViewPage(ress)}>{ress.title}</h5>
                          <h6 className="h6-client">{ress.location?.location}</h6>
                          <div className="copy" dangerouslySetInnerHTML={{ __html: ress.description }}></div>
                          <button className="butn" data-attr-track-action="job_event_click" onClick={() => moveToJobViewPage(ress)}><span>Read More</span></button>
                        </div>
                      </div>
                    </div>
                  );
                })}
                </div>
                {showPagination ? 
                  <div className="pagination">
                    <PaginationClient
                      currentPage={tableControl.currentPage}
                      totalCount={tableControl.totalCount}
                      pageSize={tableControl.pageSize?.value}
                      onPageChange={(page: any) => pageChange(page)}
                    />
                  </div>
                :
                  ""
                }
              </>
              :
              <>
                  <div>
                      <div className="job-list-parent">
                          <div className={`text-center ${noJobFoundStyle}`}>
                              {tableControl.massage}
                          </div>
                      </div>
                  </div>
              </>
            }
          </div>
          {
              clientSiteSettings?.templateName === "template_9" ?
              <>
                  <FilterPageTwo clientId={clientId} cliendConfig={clientConfig} navigateToJobAlerts={navigateToJobAlerts} navigateToJob={navigateToJob}/>
                  
                  {/* <CareersCustomFooter /> */}
              </>
                  : ""
          }
        </div>
      :
        <>
          <JobView 
            jobDataView={filterView()}
            filterListData = {filterListData} 
            tableControl = {tableControl} 
            setTableControl = {setTableControl}
            searchControlSubmit = {searchControlSubmit}
            withinDisabled = {withinDisabled}
            withinDisabledLocClass = {withinDisabledLocClass}
          />
        </>
      }
    </>
  );
};

export default JobListingsClient;